export type etalonnierPayment = 'SELLER' | 'STUD' | 'BROKER' | 'UNKNOWN'

const protrusionRoles: { key: etalonnierPayment }[] = [
  { key: 'SELLER' },
  { key: 'STUD' },
  { key: 'BROKER' },
  { key: 'UNKNOWN' },
]

export default protrusionRoles
